import type { BaseReactProps, ReactNodeDef } from '@shared/node-v1.0.0'
import { getPortDef } from '@shared/port-v1.0.0'

export type Props = BaseReactProps & {}
import Comp from '../component'

export default {
	hashTag: '#pre-release',

	module: { static: Comp },
	inNode: {
		inputs: [
			getPortDef({ name: 'w', displayName: 'Width', group: 'Dimensions', type: 'string' }),
			getPortDef({ name: 'h', displayName: 'Height', group: 'Dimensions', type: 'string' }),
			getPortDef({ name: 'opacity', displayName: 'Opacity', group: 'Styles', type: 'number', default: 1 }),
			getPortDef({ name: 'inline', displayName: 'Inline', group: 'Layout', type: 'boolean', default: true }),
		],
	},
} satisfies ReactNodeDef